<template>
  <v-data-table
    dense hide-default-header hide-default-footer
    :headers="headers"
    :items="rewards"
    :options="options"
    :mobile-breakpoint="0"
    @click:row="rewardClick"
    class="mt-1"
  >
    <template #item.completed="{ item }">
      <v-icon v-if="item.disqualified" color="red">mdi-cancel</v-icon>
      <v-icon v-else-if="item.completed" color="#3EB83D">mdi-check-circle-outline</v-icon>
      <v-icon v-else color="#FFBF00">mdi-calendar-clock</v-icon>
    </template>

    <template #item.request_time="{ item }">
      {{ $formatters.formatDate(item.request_time) }}
    </template>

    <template #item.name="{ item }">

      <div 
        v-if="item.source_type == 'from_consumer'"
        class="d-flex align-center"
        style="max-width: 205px;"
      >
        <div style="max-width: 185px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ item.name }}/{{ item.service }}
        </div>
        <v-icon class="ml-1" small color="#F47C02">mdi-qrcode</v-icon>
      </div>

      <div v-else style="max-width: 205px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        {{ item.name }}/{{ item.service }}
      </div>
    </template>

    <template #item.value_cents="{ item }">
      {{ $formatters.formatCurrency(item.value_cents) }}
    </template>

    <template #no-data>
      <div class="py-4 text-left grey--text text--darken-2">
        Get started by referring qualified pros to retail customers today. This is a 
        great way to increase customer loyalty and earn rewards at the same time.
      </div>
    </template>
  </v-data-table>
</template>

<script>
const cellClasses = 'pl-2 pr-0 grey--text text--darker-1 text-no-wrap dense-text'

export default {
  name: 'RewardsList',

  props: {
    rewards: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    headers: [
      { value: 'completed', sortable: false, cellClass: cellClasses },
      { value: 'request_time', sortable: false, cellClass: cellClasses },
      { value: 'name', sortable: false, cellClass: cellClasses + ' job' },
      { value: 'value_cents', sortable: false, align: 'right', cellClass: 'px-2 grey--text text--darker-1 dense-text' }
    ],

    options: {
      itemsPerPage: 8,
    },
  }),

  watch: {
    rewards() {
      this.options.itemsPerPage = this.rewards.length
    }
  },

  methods: {
    rewardClick(item) {
      this.$router.push({ name: 'leads/show', params: { id: item.customer_request_id } })
    },
  },
}

</script>

<style>
  .v-data-table--dense > .v-data-table__wrapper > table > tbody tr > td.dense-text { 
    font-size: 12px;
  }
</style>

<!-- display: flex;
align-items: center; -->
